import "./App.css";
import Layout from "./Component/Layout/Layout";

function App() {
  return <Layout />
}

export default App;
